import { Auth } from "aws-amplify";
import * as CONSTANTS from "@/common/constants";
import _ from "lodash";
import MESSAGE from "@/assets/json/message.json";
import AmplifyEventBus from "@/common/AmplifyEventBus";
import { IAlertInfo } from "@/types";

export default class Utils {
  public static async logout() {
    await Auth.signOut();
    AmplifyEventBus.$emit("authState", "signedOut");
  }

  // 2021-01-01T01:02:03+09:00 -> 2021年01月01日 01:02:03
  public static getApiResponseFormatDate(date: Date | null): string | null {
    let s = null;
    if (date) {
      s = `${date.getFullYear()}年${("00" + (date.getMonth() + 1)).slice(
        -2
      )}月${("00" + date.getDate()).slice(-2)}日 ${(
        "00" + date.getHours()
      ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
        "00" + date.getSeconds()
      ).slice(-2)}`;
    }
    return s;
  }

  public static getApiRequestFormatDate(date: Date | null): string | null {
    if (date === null) {
      return null;
    }
    const year: number = date.getFullYear();
    const month: number = date.getMonth() + 1;
    const day: number = date.getDate();
    return `${year}-${this.getZeroPadding(
      String(month),
      2
    )}-${this.getZeroPadding(String(day), 2)}`;
  }

  public static getZeroPadding(str: string, digitNum: number) {
    let result = str;
    let paddingStr = "";
    for (let i = 0; i < digitNum; i++) {
      paddingStr += "0";
    }
    if (str !== "" && !isNaN(Number(str))) {
      result = (paddingStr + str).slice(-digitNum);
    }
    return result;
  }

  public static showTransparentLoadingModal(bvModal: any) {
    document.body.style.cursor = "wait";
    bvModal.show(CONSTANTS.LOADING_MODAL_ID);
  }

  public static hideTransparentLoadingModal(bvModal: any) {
    // ローディングモーダルと他のモーダルが同時に表示されている場合に.
    // 同期処理だとローディングモーダルを非表示に出来ない事象が発生する為.
    // 非同期で非表示処理を行う.
    setTimeout(() => {
      bvModal.hide(CONSTANTS.LOADING_MODAL_ID);
      document.body.style.cursor = "auto";
    }, 0);
  }

  public static getCommonAlertInfo(): IAlertInfo {
    return {
      item: "",
      message: Utils.getErrorMessageByErrorCode("ES0001"),
    };
  }

  public static getErrorMessageByErrorCode(
    code: string,
    ...arrReplaceStr: string[]
  ): string {
    let message = "";
    let c = "ES0001";
    if (_.has(MESSAGE, code)) {
      c = code;
    }
    const mes: any = MESSAGE as any;
    message = mes[c];
    if (_.isArray(arrReplaceStr) && arrReplaceStr.length > 0) {
      arrReplaceStr.forEach((replaceStr, index) => {
        message =
          arrReplaceStr.length > index
            ? message.replace(`$${index + 1}`, replaceStr)
            : message;
      });
    }

    return message;
  }

  public static getErrorMessageByErrorCodeWithoutDefaultError(
    code: string,
    ...arrReplaceStr: string[]
  ): string | null {
    let message = "";
    let c = "ES0001";
    if (_.has(MESSAGE, code)) {
      c = code;
    } else {
      return null;
    }
    const mes: any = MESSAGE as any;
    message = mes[c];
    if (_.isArray(arrReplaceStr) && arrReplaceStr.length > 0) {
      arrReplaceStr.forEach((replaceStr, index) => {
        message =
          arrReplaceStr.length > index
            ? message.replace(`$${index + 1}`, replaceStr)
            : message;
      });
    }

    return message;
  }
}
